<nav
  class="mobile-bottom-nav"
  aria-label="Mobile navigation"
  (mouseleave)="_onNavMouseLeave()">
  <div
    #hoverPill
    class="mobile-bottom-nav__hover-pill"
    aria-hidden="true"
    role="presentation"></div>
  @if (sidebarEnabled()) {
    <button
      type="button"
      class="mobile-bottom-nav__item mobile-bottom-nav__item--more"
      [attr.aria-label]="'nav.more' | transloco"
      (mouseenter)="_onItemHover($event)"
      (click)="_onOpenSidebar()">
      <span class="mobile-bottom-nav__icon" aria-hidden="true">
        <app-layout-icon icon="menu" size="md" />
      </span>
      <span class="mobile-bottom-nav__label">{{ 'nav.more' | transloco }}</span>
    </button>
  }
  @for (item of navItems(); track item.path + (item.icon ?? '')) {
    @if (_isNavigable(item)) {
      <a
        [routerLink]="_resolvePath(item.path)"
        routerLinkActive="mobile-bottom-nav__item--active"
        [routerLinkActiveOptions]="{
          exact: item.path === '/home',
        }"
        class="mobile-bottom-nav__item"
        (mouseenter)="_onItemHover($event)">
        <span class="mobile-bottom-nav__icon" aria-hidden="true">
          @if (item.icon) {
            <app-layout-icon [icon]="item.icon" size="md" />
          }
        </span>
        <span class="mobile-bottom-nav__label">{{
          item.label | transloco
        }}</span>
      </a>
    } @else {
      <button
        type="button"
        class="mobile-bottom-nav__item"
        (mouseenter)="_onItemHover($event)"
        (click)="_onNonNavigableClick()">
        <span class="mobile-bottom-nav__icon" aria-hidden="true">
          @if (item.icon) {
            <app-layout-icon [icon]="item.icon" size="md" />
          }
        </span>
        <span class="mobile-bottom-nav__label">{{
          item.label | transloco
        }}</span>
      </button>
    }
  }
</nav>
